import React, { useState } from "react";

import { debounce } from "lodash";
import styled from "styled-components";

import { deleteEmpty, hasErrorObject } from "utils";
import CustomField from "components/Form/CustomField";

import { Form, Input, Schema, SelectPicker, Toggle } from "rsuite";

const { StringType, NumberType } = Schema.Types;

const model = Schema.Model({
    senderid: StringType()
        .minLength(3, "Min characters 3").maxLength(40, "Max characters 40"),
    id: StringType(),
    mcc_mnc: StringType(),
    cntr_key: NumberType()
});


const FakeDLRFilters = ({
    loading,
    disabled,
    editData,
    isMobile,
    countryList,
    operatorList,
    defaultFilter,

    renderSuppliersItem,

    setFilter,
    setEditData,
    setResetToken,
    setRemoveKeys,
    setPageState,
    getSupplierPerTrunkList
}) => {
    const onChangeFilter = (filterValue) => {
        const oldFilter = { ...filterValue };
        const newFilter = deleteEmpty(oldFilter);

        setPageState(1);
        setFilter(newFilter);
    };

    const supplierList = getSupplierPerTrunkList();

    return <StyledForm
        layout="inline"
        model={model}
        formDefaultValue={defaultFilter}
        onChange={debounce((formValue) => {
            const formCheckData = model.check(formValue);
            if (!hasErrorObject(formCheckData)) {
                onChangeFilter(formValue);
            }
        }, 500)}
    >
        <CustomField
            disabled={disabled}
            accepter={SelectPicker}
            data={supplierList}
            loading={loading}
            renderMenuItem={renderSuppliersItem}
            disabledItemValues={supplierList.filter(supplier => !supplier.trunk_id).map(supplier => supplier.id)}
            name="id"
            valueKey="id"
            labelKey="supplier_name"
            placeholder="Supplier"
            errorPlacement="topRight"
            virtualized={false}
            style={{ width: isMobile ? "100%" : 300 }}
        />
        <CustomField
            disabled={disabled}
            loading={loading}
            accepter={Input}
            name="senderid"
            placeholder="SenderID..."
            errorPlacement="topRight"
            style={{ width: isMobile ? "100%" : 220 }}
        />

        <CustomField
            disabled={disabled}
            loading={loading}
            accepter={SelectPicker}
            data={countryList}
            name="mcc"
            labelKey="mcc_name"
            valueKey="mcc"
            placeholder="Country"
            errorPlacement="topRight"
            style={{ width: isMobile ? "100%" : 220 }}
            menuStyle={{ width: 280 }}
        />
        <CustomField
            disabled={disabled}
            loading={loading}
            accepter={SelectPicker}
            data={operatorList}
            name="mcc_mnc"
            labelKey="mcc_mnc_name"
            valueKey="mcc_mnc"
            placeholder="Operator"
            errorPlacement="topRight"
            style={{ width: isMobile ? "100%" : 220 }}
            menuStyle={{ width: 280 }}
        />
        <StyledToggle
            size="lg"
            checkedChildren="Multi-row edit"
            unCheckedChildren="Single-row edit"
            defaultChecked={false}
            loading={loading}
            isMobile={isMobile}
            checked={editData.mode === "multiple"}
            onChange={(check) => {
                setResetToken((prev) => prev + 1);
                setRemoveKeys([]);
                setEditData((prev) => {
                    return {
                        ...prev,
                        mode: check ? "multiple" : "single"
                    }
                });
            }}
        />
    </StyledForm>
};

export default FakeDLRFilters;

const StyledForm = styled(Form)`
    && {
        display: flex;
        align-items: center;

        .rs-form-group, .rs-btn-toggle {
            margin-bottom: 0px;
        }
    }
`;

const StyledToggle = styled(Toggle)`
    && {
        margin-left: ${props => props.isMobile ? "0" : "15px"};
        margin-bottom: 0px;
    }
    &&.rs-btn-toggle-checked {    
        background-color: var(--color-green);
    }
    &&.rs-btn-toggle-checked:hover {
        background-color: var(--color-green-dark);
    } 
`;
